/**
 * Resetea el estado.
 *
 * @param {*} state
 */
export function resetState(state) {
    state.companies = [];
    state.locations = [];
    state.filter = {
        company: {
            id: null,
            nombre: null,
        },
        location_id: null,
        page: 1,
        perPage: 10,
        sortBy: "id",
        sort: "DESC",
        search: "",
    };
    state.reportTypes = [];
    state.levelsOfRisks = [];
    state.correctiveActions = [];
    state.activeModalForm = false;
    state.reports = [];
    state.reportTypesActives = [];
    state.levelsOfRisksActives = [];
    state.correctiveActionsActives = [];
    state.responsibles = [];
}

/**
 * Setea la sección activa.
 *
 * @param {*} state
 * @param {*} sectionActive
 */
export function setSectionActive(state, sectionActive) {
    state.sectionActive = sectionActive;
}

/**
 * Actualiza la lista de empresas.
 *
 * @param {*} state
 * @param {*} companies
 */
export function updateFindingsCompanies(state, companies) {
    state.companies = companies;
}

/**
 * Setea los tipos de reportes.
 *
 * @param {*} state
 * @param {*} reportTypes
 */
export function setReportTypes(state, reportTypes) {
    state.reportTypes = reportTypes;
}

/**
 * Setea los niveles de riesgos.
 *
 * @param {*} state
 * @param {*} levelsOfRisks
 */
export function setLevelsOfRisks(state, levelsOfRisks) {
    state.levelsOfRisks = levelsOfRisks;
}

/**
 * Setea las acciones correctivas.
 *
 * @param {*} state
 * @param {*} correctiveActions
 */
export function setCorrectiveActions(state, correctiveActions) {
    state.correctiveActions = correctiveActions;
}

/**
 * Resetea los datos.
 *
 * @param {*} state
 */
export function resetData(state) {
    state.reportTypes = [];
    state.levelsOfRisks = [];
    state.correctiveActions = [];
    state.activeModalForm = false;
    state.reports = [];
}

/**
 * Activa o desactiva el modal del formulario.
 *
 * @param {*} state
 */
export function setActiveModalForm(state) {
    state.activeModalForm = !state.activeModalForm;
}

/**
 * Setear la empresaId en el filtro.
 *
 * @param {*} state
 * @param {*} companyId
 */
export function setCompany(state, company) {
    state.filter.company.id = company;
}

/**
 * Setear los reportes.
 *
 * @param {*} state
 * @param {*} reports
 */
export function setReports(state, reports) {
    state.reports = reports;
}

/**
 * Setear ubicaciones.
 *
 * @param {*} state
 * @param {*} locations
 */
export function setLocations(state, locations) {
    state.locations = locations;
}

/**
 * Setear tipos de reportes activos.
 *
 * @param {*} state
 * @param {*} reportTypesActives
 */
export function setReportTypesActives(state, reportTypesActives) {
    state.reportTypesActives = reportTypesActives;
}

/**
 * Setear niveles de riesgos activos.
 *
 * @param {*} state
 * @param {*} levelsOfRisksActives
 */
export function setLevelsOfRisksActives(state, levelsOfRisksActives) {
    state.levelsOfRisksActives = levelsOfRisksActives;
}

/**
 * Setear acciones correctivas activas.
 *
 * @param {*} state
 * @param {*} correctiveActionsActives
 */
export function setCorrectiveActionsActives(state, correctiveActionsActives) {
    state.correctiveActionsActives = correctiveActionsActives;
}

/**
 * Setear responsables.
 *
 * @param {*} state
 * @param {*} responsibles
 */
export function setResponsibles(state, responsibles) {
    state.responsibles = responsibles;
}

/**
 * Setear el nombre de la empresa.
 *
 * @param {*} state
 * @param {*} companyName
 */
export function setCompanyName(state, companyName) {
    state.filter.company.nombre = companyName;
}

/**
 * Setear los niveles de riesgos activos menores al nivel de riesgo seleccionado.
 * @param {*} state
 * @param {*} levelsOfRisksActivesLess
 */
export function setLevelsOfRisksActivesLess(state, levelsOfRisksActivesLess) {
    state.levelsOfRisksActivesLess = levelsOfRisksActivesLess;
}


/**
 * Resetea datos de filtro de acciones correctivas.
 *
 * @param {*} state
 */
export function clearFilterPayloadCorrectAct(state) {
    const { report_id, company_id } = state.payloadCorrectAct;
    state.payloadCorrectAct = {
        report_id: report_id,
        company_id: company_id,
        responsible_id: null,
        corrective_action_id: null,
        description: null,
        is_completed: null,
        completion_date: null,
        level_risks_initial: null,
        level_risks_current: null,
        page: 1,
        per_page: 10
    };
}

/**
 * Setear id de hallazgo y compañia para obtener acciones correctivas
 *
 * @param {*} state
 */
export function setFindingtoPayloadCorrectAct(state, {id, company_id}) {
    state.payloadCorrectAct.report_id = id;
    state.payloadCorrectAct.company_id = company_id;
}

/**
 * Setear listado de acciones correctivas de un hallazgo.
 *
 * @param {*} state
 */
export function setCorrectiveActionsList(state, data) {
    state.correctiveActionsList = data;
}
